import React from "react";
import { SOCIAL } from "../constants";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" id="contact">
      <div className="footer-inner">
        <p className="footer-invite">
          Reach out to me!
        </p>
        <p className="footer-links">
          <a href={SOCIAL.email}>nl545@cornell.edu</a>
          <span aria-hidden="true"> · </span>
          <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <span aria-hidden="true"> · </span>
          <a href={SOCIAL.github} target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </p>
        <p className="footer-colophon">© {year} Nicole Luo</p>
      </div>
    </footer>
  );
}

export default Footer;
